import React, { useId } from "react";
import SVG from "react-inlinesvg";
import ReactTooltip from "react-tooltip";
import { t } from "ttag";

import QuestionMarkCircleIcon from "../../../../img/icons/question-mark-circle-filled.svg";
import { RichText } from "../../../common/RichText";

import styles from "./CompareFeatureTooltip.module.scss";

interface IProps {
    tooltip: string;
}

export const CompareFeatureTooltip = (props: IProps): React.JSX.Element => {
    const tipId = useId();
    return (
        <>
            <span data-tip={true} data-for={tipId} tabIndex={0}>
                <SVG className="tooltip__handle" src={QuestionMarkCircleIcon} />
            </span>
            <ReactTooltip
                aria-label={t`Question mark icon`}
                class="tooltip"
                event="mouseover focus"
                eventOff="scroll mousewheel mouseleave mouseout blur"
                id={tipId}
                place="right"
                role="tooltip"
                isCapture={true}
                className={styles.tooltip}
            >
                <RichText html={props.tooltip} />
            </ReactTooltip>
        </>
    );
};
